// extracted by mini-css-extract-plugin
export default {"buttonArea":"PartnerCompanies_buttonArea__ddmoi","criteriaSearchField":"PartnerCompanies_criteriaSearchField__z-Xd2","columnAlignLeft":"PartnerCompanies_columnAlignLeft__67aEN"};